import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { endPoint } from "constants/server/api";
import { createFetchLogicPrototype } from "../../utils/fetchFactory";
import { createSlicePrototype } from "../../utils/sliceFactory";
import { http } from "utils/http";
var createPesSlice = createSlicePrototype({
    name: "createPes"
});
export var createPes = createFetchLogicPrototype({
    actions: createPesSlice.actions,
    configFn: function(param, param1) {
        var payload = param.payload, accessToken = param1.accessToken;
        return {
            method: "post",
            url: "".concat(endPoint.PES),
            headers: {
                Authorization: "Bearer ".concat(accessToken)
            },
            data: payload
        };
    },
    onError: function(error, param) {
        var modalObj = param.modalObj, setModalObj = param.setModalObj;
        var getStatus = function(err) {
            return http.isAxiosError(err) && err.response ? err.response.status : 500;
        };
        var getMessage = function(err) {
            return http.isAxiosError(err) && err.response ? err.response.data.message : "เกิดข้อผิดพลาด\nหรือเครือข่ายขัดข้อง";
        };
        setModalObj === null || setModalObj === void 0 ? void 0 : setModalObj(_object_spread_props(_object_spread({}, modalObj), {
            visible: true,
            subTitle: "รหัส ".concat(getStatus(error)),
            navigateDirection: undefined,
            title: getMessage(error)
        }));
    }
});
export var clearCreatePes = function() {
    return function(dispatch) {
        dispatch(createPesSlice.actions.resetState());
    };
};
var _createPesSlice_actions = createPesSlice.actions;
export var fetchData = _createPesSlice_actions.fetchData, fetchDataSuccess = _createPesSlice_actions.fetchDataSuccess, fetchDataFailure = _createPesSlice_actions.fetchDataFailure, resetState = _createPesSlice_actions.resetState;
export default createPesSlice.reducer;
